import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogujratcab() {



    const cardData = {

keyword: "Mumbai to Gujarat Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Gujarat Cab services for intercity travel, business trips, family tours, pilgrimage journeys, and one-way or round-trip travel. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup in Mumbai, and safe highway driving across Maharashtra and Gujarat routes, we ensure a smooth, comfortable, and hassle-free travel experience to all major cities in Gujarat.",

topPlaces: [
    {
        title: "Ahmedabad Sabarmati Riverfront",
        description:
            "The Sabarmati Riverfront is a beautifully developed urban waterfront in Ahmedabad known for its walking paths, gardens, and evening views along the river."
    },
    {
        title: "Statue of Unity (Kevadia)",
        description:
            "The Statue of Unity is the world’s tallest statue dedicated to Sardar Vallabhbhai Patel and is one of India’s top tourist attractions in Gujarat."
    },
    {
        title: "Gir National Park",
        description:
            "Gir National Park is the only natural habitat of Asiatic lions in the world and is a must-visit destination for wildlife lovers traveling from Mumbai."
    },
    {
        title: "Somnath Temple",
        description:
            "Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva and a highly sacred pilgrimage destination located along the Arabian Sea coast."
    },
    {
        title: "Dwarka",
        description:
            "Dwarka is one of the Char Dham pilgrimage sites associated with Lord Krishna and attracts millions of devotees every year."
    },
    {
        title: "Rann of Kutch",
        description:
            "The Rann of Kutch is a vast white salt desert famous for the Rann Utsav, cultural festivals, and breathtaking landscapes."
    },
    {
        title: "Vadodara Laxmi Vilas Palace",
        description:
            "Laxmi Vilas Palace in Vadodara is one of India’s grandest royal palaces showcasing stunning architecture and royal heritage."
    },
    {
        title: "Saputara Hill Station",
        description:
            "Saputara is Gujarat’s only hill station known for lakes, viewpoints, ropeway rides, and cool weather in the Sahyadri hills."
    },
    {
        title: "Champaner-Pavagadh",
        description:
            "Champaner-Pavagadh Archaeological Park is a UNESCO World Heritage Site known for forts, temples, and ancient Islamic architecture."
    },
    {
        title: "Kutch Bhuj City",
        description:
            "Bhuj is a cultural gateway to the Kutch region known for handicrafts, museums, palaces, and traditional Gujarati culture."
    }
],



services: [
{
name: "Mumbai to Gujarat Cab",
description: "Mumbai Airport Cab offers Mumbai to Gujarat Cab service for safe, comfortable, and reliable long-distance intercity travel from Mumbai to major cities across Gujarat. Whether you are travelling for business, family visits, tourism, industrial work, or relocation, we provide well-maintained vehicles including Sedan, SUV, Innova, Innova Crysta, Kia Carens, Tempo Traveller, and luxury cars. Our professional chauffeurs ensure smooth highway driving, timely pickup, passenger safety, and stress-free journey experience. With doorstep pickup from Mumbai, flexible travel planning, transparent pricing, luggage assistance, and 24x7 support, we make your Gujarat travel convenient and comfortable."
},
{
name: "Mumbai to Gujarat Taxi",
description: "Mumbai to Gujarat Taxi service by Mumbai Airport Cab provides dependable intercity transportation with clean, air-conditioned vehicles and experienced chauffeurs. Ideal for families, corporate travellers, and tourists, we ensure safe highway travel, punctual pickup, and comfortable seating for a smooth journey from Mumbai to Gujarat."
},
{
name: "Mumbai to Gujarat Cab Fare",
description: "Mumbai to Gujarat Cab Fare with Mumbai Airport Cab is transparent, affordable, and based on vehicle type, distance, and travel requirements. We provide clear pricing with no hidden charges and flexible one-way and round-trip options, ensuring cost-effective long-distance travel with comfort and reliability."
},
{
name: "Mumbai to Gujarat Car Rental",
description: "Mumbai Airport Cab offers Mumbai to Gujarat Car Rental service with chauffeur-driven vehicles for long-distance intercity travel. Our fleet includes comfortable sedans and spacious SUVs ideal for business trips, family travel, and tourism. We ensure safe driving, luggage support, and flexible itineraries for a smooth travel experience."
},
{
name: "Mumbai to Gujarat One Way Cab",
description: "Mumbai to Gujarat One Way Cab service provides affordable travel for passengers who need a single journey without return charges. Mumbai Airport Cab ensures transparent pricing, comfortable vehicles, and professional chauffeurs for intercity relocation, tourism, and business travel."
},
{
name: "Mumbai to Gujarat Outstation Cab",
description: "Mumbai to Gujarat Outstation Cab service offers reliable long-distance transportation with well-maintained vehicles and experienced drivers. Mumbai Airport Cab ensures safe highway driving, flexible schedules, and comfortable seating for stress-free intercity journeys."
},
{
name: "Mumbai to Gujarat Intercity Cab",
description: "Mumbai to Gujarat Intercity Cab service provides smooth and efficient transportation between Mumbai and multiple cities in Gujarat. Mumbai Airport Cab ensures professional chauffeurs, clean vehicles, and comfortable travel for business and personal trips."
},
{
name: "Mumbai to Gujarat Business Cab",
description: "Mumbai to Gujarat Business Cab service is designed for corporate professionals requiring punctual and reliable transportation. Mumbai Airport Cab ensures executive comfort, professional chauffeurs, and timely service for productive business travel."
},
{
name: "Mumbai to Gujarat Family Cab",
description: "Mumbai to Gujarat Family Cab service ensures safe and comfortable transportation for families travelling together. Mumbai Airport Cab provides spacious vehicles, luggage-friendly travel, experienced chauffeurs, and flexible booking options for stress-free long journeys."
},
{
name: "Mumbai to Gujarat Innova Cab",
description: "Mumbai Airport Cab offers Mumbai to Gujarat Innova Cab service for families and groups needing spacious and comfortable travel. Our Innova vehicles provide ample seating, luggage space, and smooth ride quality for long-distance journeys."
},
{
name: "Mumbai to Gujarat SUV Cab",
description: "Mumbai to Gujarat SUV Cab service provides powerful and comfortable vehicles suitable for long highway travel. Mumbai Airport Cab ensures safe driving, spacious interiors, and smooth journey experience for families and groups travelling together."
},
{
name: "Mumbai to Gujarat Round Trip Cab",
description: "Mumbai to Gujarat Round Trip Cab service offers complete return journey solutions for business trips, tourism, and family travel. Mumbai Airport Cab ensures flexible scheduling, professional chauffeurs, and comfortable vehicles for a smooth round trip experience."
},
{
name: "Mumbai to Gujarat Travel Service",
description: "Mumbai to Gujarat Travel Service provides complete transportation solutions for tourists, families, and corporate travellers. Mumbai Airport Cab ensures safe, comfortable, and well-organized intercity travel with professional drivers and flexible itineraries."
},
{
name: "Mumbai to Gujarat Highway Cab",
description: "Mumbai to Gujarat Highway Cab service ensures safe and efficient long-distance travel across major highway routes. Mumbai Airport Cab provides experienced chauffeurs, optimized routes, and well-maintained vehicles for smooth intercity journeys."
},
{
name: "Mumbai to Gujarat Budget Cab",
description: "Mumbai to Gujarat Budget Cab service offers economical travel solutions without compromising safety or comfort. Mumbai Airport Cab ensures affordable pricing, clean vehicles, and reliable drivers for cost-effective long-distance travel."
},
{
name: "Mumbai to Gujarat Express Cab",
description: "Mumbai to Gujarat Express Cab service provides fast and efficient transportation for urgent travel needs. Mumbai Airport Cab ensures quick pickup, optimized routes, and professional drivers for timely arrival at your destination."
},
{
name: "Mumbai to Gujarat Night Travel Cab",
description: "Mumbai to Gujarat Night Travel Cab service provides safe overnight transportation for long-distance travellers. Mumbai Airport Cab ensures experienced drivers, secure travel conditions, and comfortable vehicles for peaceful night journeys."
},
{
name: "Mumbai to Gujarat Tour Cab",
description: "Mumbai to Gujarat Tour Cab service offers customized travel solutions for sightseeing and tourism across Gujarat. Mumbai Airport Cab ensures comfortable vehicles, flexible itineraries, and professional chauffeurs for a smooth travel experience."
},
{
name: "Mumbai to Gujarat Corporate Cab",
description: "Mumbai to Gujarat Corporate Cab service is designed for business organizations and professionals requiring reliable transportation. Mumbai Airport Cab ensures punctual service, executive comfort, and professional chauffeurs for seamless corporate travel."
}
],

tableData: [
["Mumbai to Gujarat Cab","Mumbai to Gujarat Taxi"],
["Mumbai to Gujarat Cab Fare","Mumbai to Gujarat Car Rental"],
["Mumbai to Gujarat One Way Cab","Mumbai to Gujarat Outstation Cab"],
["Mumbai to Gujarat Intercity Cab","Mumbai to Gujarat Business Cab"],
["Mumbai to Gujarat Family Cab","Mumbai to Gujarat Innova Cab"],
["Mumbai to Gujarat SUV Cab","Mumbai to Gujarat Round Trip Cab"],
["Mumbai to Gujarat Travel Service","Mumbai to Gujarat Highway Cab"],
["Mumbai to Gujarat Budget Cab","Mumbai to Gujarat Express Cab"],
["Mumbai to Gujarat Night Travel Cab","Mumbai to Gujarat Tour Cab"]
],

















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Gujarat Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Gujarat Cab services for business travelers, families, tourists, industrial visitors, pilgrims, and long-distance travelers seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Travel Across Major Gujarat Cities",
        WhyChoosedescription: "Customers can book cabs from Mumbai to Ahmedabad, Vadodara, Surat, Rajkot, Jamnagar, Bhavnagar, Gandhinagar, Dwarka, Somnath, and other destinations across Gujarat."
    },
    {
        WhyChooseheading: "Perfect for Business and Industrial Travel",
        WhyChoosedescription: "Gujarat is one of India's leading business and industrial states, making our cab service ideal for corporate meetings, factory visits, exhibitions, and official travel."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Facilities",
        WhyChoosedescription: "Whether you require a one-way transfer, round trip, multi-city Gujarat tour, or customized travel itinerary, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Dombivli, Kalyan, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Interstate Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced in interstate highway travel and ensure safe, comfortable, and hassle-free transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Corporate Travelers, and Groups",
        WhyChoosedescription: "From solo travelers and families to corporate teams and tourist groups, we provide suitable vehicles for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Which Gujarat destinations can I travel to from Mumbai?",
        answer: "Customers can book cabs to Ahmedabad, Surat, Vadodara, Rajkot, Dwarka, Somnath, Jamnagar, Bhavnagar, Gandhinagar, Bhuj, and other destinations across Gujarat."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Gujarat?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Gujarat travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Gujarat travel?",
        answer: "Sedan cars, Ertiga, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Do you provide Gujarat tour packages?",
        answer: "Yes, customers can book customized Gujarat tours covering Ahmedabad, Dwarka, Somnath, Statue of Unity, Gir National Park, and other attractions."
    },
    {
        question: "Can corporate travelers use this service regularly?",
        answer: "Yes, many business owners, industrial visitors, executives, and corporate clients regularly use our Mumbai to Gujarat Cab services."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate teams, religious tours, and tourist groups."
    },
    {
        question: "Can multiple cities be covered during the trip?",
        answer: "Yes, customers can customize their itinerary and include multiple Gujarat cities, business locations, temples, tourist attractions, and personal stops."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Mumbai to Gujarat travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning, especially for long-distance journeys."
    },
    {
        question: "How can I book a Mumbai to Gujarat Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harsh Patel",
        feedback:
            "We booked a cab from Mumbai for a multi-city Gujarat business trip. The vehicle was comfortable, the driver was experienced, and the entire journey was professionally managed.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Bhakti Shah",
        feedback:
            "Our family tour covering Dwarka and Somnath was extremely enjoyable. Mumbai Airport Cabs provided excellent service, a clean vehicle, and a smooth travel experience throughout the trip.",
        rating: 5
    }
];






























   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Gujarat Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-gujarat-cab.jpg",
"description": "Book Mumbai to Gujarat cab service for long-distance travel, intercity trips, business travel, and family journeys. Mumbai Airport Cabs offers reliable outstation taxi service with professional drivers, comfortable sedans, SUVs, and Innova vehicles, plus flexible one-way and round-trip options.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-gujarat-cab"
}
};




    return (
        <div>




<Helmet>
  <title>Mumbai to Gujarat Cab | Intercity Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Gujarat cab for intercity travel, business trips, and family journeys. Comfortable outstation taxi service with sedans, SUVs, and Innova options available 24x7."
/>

<meta
 name="keywords"
 content="mumbai to gujarat cab, mumbai to gujarat taxi, mumbai to gujarat cab fare, mumbai to gujarat car rental, mumbai to gujarat one way cab, mumbai to gujarat outstation cab, mumbai to gujarat intercity cab, mumbai to gujarat business cab, mumbai to gujarat family cab, mumbai to gujarat innova cab, mumbai to gujarat suv cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/41.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitogujratcab;